import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

import StandardModeHeader from "../../components/Table/components/headerComponents/StandardModeHeader";
import AdvancedModeHeader from "../../components/Table/components/headerComponents/AdvancedModeHeader";
import { VIEWNAME } from "../../utils/GeneralUtils";

export interface IBaseOptionsHeaderOwnProps {
    /** Whether or not the edit mode is active (default: false) */
    inEditMode: boolean;
   
    /** Number of selected rows in the displayed table. */
    selectedRows: number;

    hasNewButton: boolean;
    hasEditButton: boolean;
    hasReloadButton: boolean;

    /** Callback for when the 'select modelyear' button was clicked. */
    onSelectModelyearClicked?: () => any;

    /** Callback for when the 'init PSL' button was clicked. */
    onClickInitPslButton?: () => any;

    /** Callback for when the 'copy modelyear' button was clicked. */
    onClickCopyYearButton?: () => any;

    /** Callback for when the 'add' button was clicked. */
    onClickNewButton?: () => any;

    /** Callback for when the 'edit' button was clicked. */
    onClickEditButton?: () => any;

    /** Callback for when the 'delete' button was clicked. */
    onClickDeleteButton?: () => any;

    /** Callback for when the 'refresh' button was clicked. */
    onClickReloadButton: () => any;

    /** Callback for when the 'history' button was clicked. */
    onClickHistoryButton?: () => any;

    isSelected: boolean;

    labelEditButton: string;
    labelNewButton: string;
    labelReloadButton: string;
    labelCopyYearButton?: string;
    hasHistoryButton: boolean;
    labelHistoryButton: string;
    disableHistoryButton: boolean;
    hasDeleteButton: boolean;
    labelDeleteButton: string;
    labelPslButton: string;
    hasInitPslButton: boolean;
    iconNewButton?: string;
    switchHeaderMode: boolean;
    viewName: VIEWNAME;
    hasCheckPCCDSyncronisationButton:boolean;
    onClickCheckPCCDSyncronisationButton:()=>void;
    disableCheckPCCDSyncronisationButton:boolean;
    labelCheckPCCDSyncronisationButton?:string;
    hasAsisigmantsAction:boolean;
}

export interface IBaseOptionsHeaderProps extends ITranslatedComponent, IBaseOptionsHeaderOwnProps {

}
/**
 * Header of the BaseOptionsView.
 * Contains functionality related to both OptionBasic and StdEquipment.
 */
const BaseOptionsHeader: React.SFC<IBaseOptionsHeaderProps> = (props) => (
    <div className='action-header-container display--flex align-items--center' style={{padding: "5px 10px"}}>
        {props.switchHeaderMode ?
            <AdvancedModeHeader {...props} /> :
            <StandardModeHeader  {...props} />
        }
    </div>
);

export default translate(["BASEOPTIONS", "GLOBAL"])(BaseOptionsHeader);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/BaseOptionsHeader.tsx